<script setup>
const route = useRoute()
const { data: cityConfig } = await useFetch('/api/wind/cityCode', { query: { citycode: route.params.city } })
if (!cityConfig.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
useCustomMeta('city', cityConfig.value.name, getFullPrefectureName(route.params.pref, 'area'))
const breadCrumbList = getBreadCrumb(route.params.area, route.params.pref, cityConfig.value.name)
const { data: mapPosition } = await useFetch('/api/wind/mapConfig', { query: { path: route.params.city } })
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :pref="getAreaPrefectureName(route.params.pref)"
      :pref-roma="route.params.pref"
    >
      <div class="frame">
        <WindMap
          :map-position="mapPosition"
          :title="cityConfig.name"
        />
      </div>
      <template #main-bottom>
        <WindCityList :pref="route.params.pref" />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
